import { BlurEvent, Textbox, Snackbar, DataSourceMode, DataSourceModeChangeEvent } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutGeographicCity } from "./autogen/AutogenLayoutGeographicCity";

export class GeographicCity extends AutogenLayoutGeographicCity {

    textboxLatLongOnBlur(event: BlurEvent) {
        const textbox = event.target as Textbox;
        const latLongText = textbox.text;
        if (StringUtil.isEmptyString(latLongText)) {
            return;
        }
        const latLongNumber: number = parseFloat(latLongText);
        if (isNaN(latLongNumber)) {
            Snackbar.showWarningSnackbar(`${textbox.caption} must be a valid number`);
            textbox.text = null;
            textbox.focus();
            return;
        }
        if (latLongNumber < 0) {
            Snackbar.showWarningSnackbar(`${textbox.caption} must be a positive number`);
            textbox.text = null;
            textbox.focus();
            return;
        }
    }

    sourceGeographicCityAfterModeChange(event: DataSourceModeChangeEvent) {
        if (event.newMode === DataSourceMode.ADD) {
            this.switchStatus.checked = true;
        }
    }
}
